module.exports = __webpack_public_path__ + "img/6.e3e33a6b.png";